import React, { useContext, useEffect } from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import NavContext from "../../context/NavContext";
import LoaderLogin from "../UiComponents/loader/LoaderLogin";
import { PermissionsProvider } from "../../context/PermissionsContext";

export default function Private() {
  const { userAuth, loading } = useContext(NavContext);
  const location = useLocation();

  // console.groupCollapsed("🔐 [Private Route]");
  // console.log("➡️ Pathname        :", location.pathname);
  // console.log("➡️ Loading         :", loading);
  // console.log("➡️ userAuth        :", userAuth);
  // console.groupEnd();

  // 🔥 Cas 1 : Chargement des données (vérif token, userConnect, etc.)
  if (loading) {
    console.warn("⏳ Loading actif → Affichage du loader");
    return (
      <div className="container">
        <LoaderLogin />
      </div>
    );
  }

  // 🔥 Cas 2 : Utilisateur non connecté → Redirection
  if (!userAuth) {
    // console.warn(
    //   "🚫 Accès refusé : utilisateur NON AUTHENTIFIÉ → redirection vers / (page de login)"
    // );
    return <Navigate to="/" replace />;
  }

  // 🔥 Cas 3 : Authentifié → Affichage des routes privées
  // console.log("✅ Accès autorisé → Affichage des routes privées");

  return (
    <div className="container">
      <PermissionsProvider> 
      <Outlet />
      </PermissionsProvider>
    </div>
  );
}
